import type { BrigadeRating } from "@/app/api/types";

export type BrigadeRatingStatus = "GREEN" | "YELLOW" | "RED";

export const BRIGADE_RATING_COLORS: Record<BrigadeRatingStatus, string> = {
	GREEN: "#22c55e",
	YELLOW: "#eab308",
	RED: "#ef4444",
};

export const BRIGADE_RATING_LABELS: Record<BrigadeRatingStatus, string> = {
	GREEN: "Barcha topshiriqlar bajarilgan",
	YELLOW: "Bugungi topshiriq bajarilmagan",
	RED: "Muddati o'tgan topshiriq bor",
};

/**
 * Priority: overdue tasks always win (red) even if some are also due today;
 * due-today-only is a warning (yellow); no incomplete tasks at all is green.
 */
export function brigadeRatingStatus(
	rating: Pick<BrigadeRating, "overdueIncompleteCount" | "dueTodayIncompleteCount">
): BrigadeRatingStatus {
	if (rating.overdueIncompleteCount > 0) {
		return "RED";
	}
	if (rating.dueTodayIncompleteCount > 0) {
		return "YELLOW";
	}
	return "GREEN";
}

/** 1 overdue task -> 20% opacity, 25+ -> 100%, linear in between. */
export function brigadeOverdueOpacity(overdueIncompleteCount: number): number {
	if (overdueIncompleteCount <= 0) {
		return 0;
	}
	const ratio = (overdueIncompleteCount - 1) / 24;
	return Math.min(1, 0.2 + ratio * 0.8);
}
